export function saleReducer(state = {
    SALES : {},
    REAPPRO : {},
    REAPPRO_EXT : {},
    REA_DRAFTS : {},
    DEVIS : {},
    ALL: {}
},{
    type,
    payload
}){
    
    switch(type){
        case "NEW_SALE":  
            let list = Object.assign({}, state)
            list.ALL = {[payload.id] : payload, ...list.ALL}
            list.SALES = {[payload.id] : payload, ...list.SALES}
           
            return list

        case "UPDATE_SALE":  
            return {
                ...state,
                ALL: {
                    ...state.ALL,
                    [payload.id]: payload
                },
                SALES: {
                    ...state.SALES,
                    [payload.id]: payload
                }
            }
            
        case "NEW_SALE_REAPPRO":  
            return {
                ...state,
                ALL: {
                    ...state.ALL,
                    [payload.id]: payload
                },
                REAPPRO: {
                    ...state.REAPPRO,
                    [payload.id]: payload
                }
            }
        case "NEW_SALE_REA_DRAFT":  
            return {
                ...state,
                ALL: {
                    ...state.ALL,
                    [payload.id]: payload
                },
                REA_DRAFT: {
                    ...state.REA_DRAFT,
                    [payload.id]: payload
                }
            }
        case "NEW_REAPPRO_EXT":
            return {
                ...state,
                ALL: {
                    [payload.id]: payload,
                    ...state.ALL
                },
                REAPPRO_EXT: {
                    [payload.id]: payload,
                    ...state.REAPPRO_EXT
                }
            }
        case "NEW_SALE_DEVIS":  
            return {
                ...state,
                ALL: {
                    [payload.id]: payload,
                    ...state.ALL
                },
                DEVIS: {
                    [payload.id]: payload,
                    ...state.DEVIS
                }
            }
        case "GET_SALES":
            return {
                ...state,
                SALES: payload
            }

        case "GET_REAPPRO":
            return {
                ...state,
                REAPPRO: payload
            }

        case "GET_REA_DRAFTS":
            return {
                ...state,
                REA_DRAFTS: payload
            }

        case "GET_REAPPRO_EXT":
            return {
                ...state,
                REAPPRO_EXT: payload
            }
            
        // case "GET_SALES":
        case "GET_SALE":
            return payload;

        case "DELETE_PREPA":
        case "DELETE_SALE":
            const { [payload]: deletedFromAll, ...newAll } = state.ALL;
            const { [payload]: deletedFromSales, ...newSales } = state.SALES;
            
            return {
                ...state,
                ALL: newAll,
                SALES: newSales
            }

        case "DELETE_REAPPRO":
            const { [payload]: deletedFromAllReappro, ...newAllReappro } = state.ALL;
            const { [payload]: deletedFromReappro, ...newReappro } = state.REAPPRO;
            
            return {
                ...state,
                ALL: newAllReappro,
                REAPPRO: newReappro
            }

        case "UPDATE_SALES_LINK":
            console.log('====================================');
            console.log({payload});
            console.log('====================================');

            const updatedAllLink = { ...state.ALL };
            const updatedSalesLink = { ...state.SALES };
            
            payload.list.forEach( ID => {
                if (updatedAllLink[ID]) {
                    updatedAllLink[ID] = {
                        ...updatedAllLink[ID],
                        fact_id_5000: payload.income_id
                    };
                }
                if (updatedSalesLink[ID]) {
                    updatedSalesLink[ID] = {
                        ...updatedSalesLink[ID],
                        fact_id_5000: payload.income_id
                    };
                }
            });
            
            return {
                ...state,
                ALL: updatedAllLink,
                SALES: updatedSalesLink
            }
            
        case "UPDATE_SALES_UNLINK":
            const updatedAllUnlink = { ...state.ALL };
            const updatedSalesUnlink = { ...state.SALES };
            
            payload.list.forEach( ID => {
                if (updatedAllUnlink[ID]) {
                    updatedAllUnlink[ID] = {
                        ...updatedAllUnlink[ID],
                        fact_id_5000: ""
                    };
                }
                if (updatedSalesUnlink[ID]) {
                    updatedSalesUnlink[ID] = {
                        ...updatedSalesUnlink[ID],
                        fact_id_5000: ""
                    };
                }
            });
            
            return {
                ...state,
                ALL: updatedAllUnlink,
                SALES: updatedSalesUnlink
            };

        // case "UPDATE_SALE_ITEM_QTY":
        //     let list10 = Object.assign({}, state)
        //         list10.ALL[payload.sale_id].products.forEach( (prod, index) => {
        //             if (prod.id === payload.id) {
        //                 list10.ALL[payload.sale_id].products[index].rest_to_return = payload.rest_to_return
        //             }
        //         })
        //         list10.SALES[payload.sale_id].products.forEach( (prod, index) => {
        //             if (prod.id === payload.id) {
        //                 list10.ALL[payload.sale_id].products[index].rest_to_return = payload.rest_to_return
        //             }
        //         })
        //     return list10;
        case "UPDATE_REAPPRO": 
            return {
                ...state,
                ALL: {
                    ...state.ALL,
                    [payload.id]: payload
                },
                REAPPRO: {
                    ...state.REAPPRO,
                    [payload.id]: payload
                }
            }
        default:
            return state;
    }
    
}